{
  "configuration": {
    "name_label": "Nombre"
  },
  "heatmap_widget": {
    "title": "Widget de Parámetro",
    "config_dialog_title": "Widget de Parámetro"
  },
  "widgets": {
    "actions": {
      "resize": "Redimensionar",
      "config": "Editar",
      "move": "Mover",
      "remove": "Eliminar"
    },
    "time_period": "Periodo de tiempo",
    "choose_period": "Seleccionar periodo...",
    "live": "En vivo",
    "last_day": "Ayer",
    "last_week": "La semana pasada",
    "maximum_widget_number_reached": "Lo sentimos. No puede agregar más widgets.",
    "open_monitor_page": "Abrir el monitor",
    "chart_widget_min_selected": "debe tener al menos un punto de datos seleccionado"
  },
  "blocks_widget": {
    "empty_data_point": "no hay puntos de datos para consultarlos",
    "title": "Widget de Bloques",
    "config_dialog_title": "Bloques de widgets"
  },
  "node_widget": {
    "empty_data_point": "no hay puntos de datos para consultarlos",
    "title": "Widget de Dispositivo",
    "config_dialog_title": "Nodo del widget",
    "last_time_reported": "Última vez que se informó<br />%{value}"
  },
  "text_widget": {
    "title": "Editar Texto",
    "config_dialog_title": "Editar texto"
  },
  "chart_widget": {
    "title": "Widget de Gráfico",
    "config_dialog_title": "Gráfico del widget",
    "group_ungroup_title": "Agrupar/Desagrupar por unidad",
    "ordinal_title": "Mostrar/Ocultar huecos de datos",
    "reset_selected_range": "Restablecer el rango seleccionado",
    "group_axis": "Agrupar eje"
  },
  "connectivity_widget": {
    "title": "Widget de Conectividad",
    "config_dialog_title": "Widget de Conectividad"
  },
  "distribution_widget": {
    "title": "Widget de Distribución",
    "config_dialog_title": "Widget de Distribución",
    "default_name": "Distribución de %{parameter}",
    "interval_minutes": "%{n} min",
    "interval_hours": "%{n} h",
    "too_many_readings": "Demasiadas lecturas para mostrar. Elija un intervalo de agregación o un rango de tiempo más corto.",
    "stats": {
      "min": "Mín",
      "avg": "Prom",
      "max": "Máx"
    },
    "errors": {
      "parameter_required": "Seleccione un parámetro",
      "one_parameter": "Seleccione el mismo parámetro en cada dispositivo"
    }
  },
  "compare_devices_widget": {
    "title": "Widget de Comparación de Dispositivos",
    "config_dialog_title": "Widget de Comparación de Dispositivos",
    "group_ungroup_title": "Agrupar/Desagrupar por unidad",
    "reset_selected_range": "Restablecer el rango seleccionado",
    "group_axis": "Agrupar eje"
  },
  "wind_rose_widget": {
    "title": "Widget de Rosa de los Vientos",
    "config_dialog_title": "Rosa de los Vientos",
    "wind_speed_label": "Velocidad del Viento",
    "wind_direction_label": "Dirección del Viento"
  },
  "map_widget": {
    "title": "Widget de Mapa",
    "config_dialog_title": "Mapa del widget",
    "no_location": "La ubicación NO está disponible",
    "air_quality": "Calidad del aire"
  },
  "table_widget": {
    "title": "Widget de Tabla",
    "config_dialog_title": "Tablero del widget"
  },
  "thiamis_widget": {
    "title": "Dispositivo Thiamis",
    "config_dialog_title": "Dispositivo de Thiamis"
  },
  "info_widget": {
    "title": "Widget de Información de Nodo",
    "config_dialog_title": "Información del nodo del widget"
  },
  "sensor_widget": {
    "config_dialog_title_new": "Agregar sensor"
  },
  "modules_widget": {
    "title": "Módulo de Expansión %{name}",
    "config_dialog_title": "Módulo de expansión %{name}"
  },
  "total_devices_online_pie_chart_widget": {
    "title": "Total de Dispositivos"
  },
  "total_devices_online_column_chart_widget": {
    "title": "Total de Dispositivos por Tipo"
  },
  "devices_online_chart_widget": {
    "title": "Dispositivos en Línea"
  },
  "recent_alerts_widget": {
    "title": "Alertas Recientes"
  },
  "recent_measurements_widget": {
    "local_time": "Hora local del dispositivo",
    "local_time_title": "Hora local del dispositivo<br /><small>%{timezone}</small>",
    "deselect_all_data_points": "Desmarcar todos los puntos de datos"
  },
  "heatmap_legend": {
    "excellent": "Excelente",
    "good": "Bueno",
    "satisfactory": "Satisfactorio",
    "moderate": "Moderado",
    "poor": "Pobre",
    "veryPoor": "Muy Pobre",
    "offline": "Desconectado",
    "online": "Conectado"
  }
}
